"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FifteenYearsOfJoyfulCelebrations() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="222077" id="our-legacy-and-reach" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-12 items-center">
          
          {}
          <div ref={contentRef} className={`lg:col-span-6 relative transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="hidden absolute -top-16 -left-8 md:-top-24 md:-left-12 text-[12rem] md:text-[18rem] font-serif font-bold leading-none select-none pointer-events-none z-0 opacity-10 dark:opacity-5" style={{
            WebkitTextStroke: "1px var(--color-primary)",
            color: "transparent"
          }} aria-hidden="true">
              75
            </div>

            <div className="relative z-10">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-normal text-primary mb-6 leading-none"><span className="!text-4xl"></span><span className="!text-4xl"><span className="!text-4xl ![line-height:16px]">Engineered w</span>ith Purpose. <br />Built with Standards. <br />Improved through Experience.</span></h2>
              
              <div className="space-y-6 text-base font-default text-muted-foreground max-w-2xl mb-12">
                <p>Since our founding in 2006, ABCO South has established itself as a trusted commercial and industrial electrical and automation contractor across the Southern United States. We specialize in high-stakes heavy commercial and industrial operations, delivering sophisticated electrical and automation solutions thru small to large-scale electrical and automation installations that demand precision.</p>
                <p>Our legacy is built on a foundation of uncompromising safety and technical mastery in the electrical and automation field. By employing some of the region's most seasoned electrical and automation specialists, we ensure that every project is executed on time and in a professional and accurate manner.</p>
                <p>We take pride in our operational reach, providing the electrical and automation expertise required to navigate the most demanding challenges in the industry. Our team brings decades of collective experience to the field, transforming complex engineering and design requirements into operational successes.</p>
                <p>As we continue to expand our footprint, our commitment remains focused on driving commercial and industrial excellence through electrical and automation innovation and execution. We are more than just a service provider; we are a dedicated partner in designing, engineering , building and maintaining the electrical infrastructure and automation systems that powers our economy.</p>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-6 relative transition-all duration-1000 delay-300 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="relative w-full aspect-[3/4] md:aspect-[4/5] mx-auto lg:max-w-none">
              {}
              <div className="w-full h-full rounded-md overflow-hidden shadow-sm border border-border relative z-10">
                <Link className="w-full h-full object-cover transition-transform duration-700 hover:scale-105 underline cursor-pointer" to="/HomePage"><img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_facility_crane_operation.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_facility_crane_operation.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_facility_crane_operation.png-wvc-sizes" alt="ABCO South heavy machinery and industrial crane operation on site" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" loading="lazy" /></Link>
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />
              </div>

              {}
              <div className="absolute -bottom-8 -right-4 md:-bottom-12 md:-right-8 z-20">
                <div className="size-32 md:size-40 rounded-lg bg-primary shadow-md flex items-center justify-center p-4 border-4 border-background transform transition-transform hover:scale-105 duration-500">
                  <div className="text-center">
                    <span className="block text-primary-foreground font-default text-xl md:text-2xl font-bold leading-tight">
                      Est. 2006
                    </span>
                  </div>
                </div>
              </div>
              
              {}
              <div className="absolute -inset-4 bg-secondary/10 rounded-md -z-10 transform translate-x-4 translate-y-4 border border-secondary/20" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}